import { Observable } from "rxjs";
import { LoadingEventType } from "../../enums/loadingEventType";

const IMessagingServiceId = Symbol("IMessagingService");

interface IMessagingService {

    StartLoadingEvent(id: string, type: LoadingEventType);
    EndLoadingEvent(id: string);
    OnLoading(): Observable<boolean>;
}

export { IMessagingServiceId, IMessagingService };